import { Pipe, PipeTransform } from '@angular/core';
import { PermissionService } from '../services/permission.service';

@Pipe({
  name: 'permissionCheck'
})
export class PermissionCheckPipe implements PipeTransform {

  constructor(private permissionService:PermissionService){}

  transform(permissions: any): boolean {
    return this.permissionService.checkPermission(permissions);
  }

}
